import React, { Component } from 'react';
import { css } from 'react-emotion';
import { Field } from 'redux-form';

import AddCatalogPriceContract from './AddCatalogPriceContract';
import { TermTypeLabel } from '../../../../constants/termTypes';
import OptionCardField from './OptionCardField';
import StepTitle from '../../../common/StepTitle';
import { withTranslation } from 'react-i18next';

const optionCardStyle = css({
  maxWidth: '600px',
  margin: '0px auto'
});

const contractDetailsType = css({
  width: '350px'
});

class AddContract extends Component {
  render() {
    const { t } = this.props;

    const buyerPricingTypeOptionsMap = {};

    const termPricingTypeLabels = [TermTypeLabel.LIST_PRICE].map(type => ({ value: type, label: t(type) }));

    buyerPricingTypeOptionsMap[TermTypeLabel.LIST_PRICE] = () => (
      <AddCatalogPriceContract className={contractDetailsType} />
    );

    return (
      <div>
        <StepTitle icon="product-pricing-terms-l" title={t('createContract:addContract.title')} />
        <Field
          className={optionCardStyle}
          component={OptionCardField}
          name="pricingContractType"
          optionsLabel={t('common:commonTerminology.contractType')}
          options={termPricingTypeLabels}
          optionsActionMap={buyerPricingTypeOptionsMap}
        />
      </div>
    );
  }
}

export default withTranslation()(AddContract);
